module.exports = __webpack_public_path__ + "static/media/facebook.3a553404.svg";